import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import {BarBase} from "./bar_base";

class BarRaw extends BarBase {
    protected allChartOptions(): Options {
        const options: Options = {
            xAxis: {
                plotBands: [{
                    color: {
                        linearGradient: {x1: 0, y1: 0, x2: 1, y2: 0},
                        stops: [
                            [0, '#90e0ef'],
                            [0.5, '#caf0f8'],
                            [1, '#fff'],
                        ]
                    },
                    from: 4.5,
                    to: 5.5,
                }],
            },
        };

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

// noinspection JSUnusedGlobalSymbols
export default function () {registerPlugin(BarRaw)}